[
  {
    "id": "MET-OMT-L1-001",
    "module": "Metriek",
    "difficulty": 104,
    "question": "Hoeveel meter hek is er nodig voor de hele tuin?",
    "options": [
      "20 meter",
      "40 meter",
      "96 meter",
      "80 meter"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "omtrek",
    "subSkill": "omtrek",
    "familyId": "MET-OMT-TUIN",
    "context": "Een tuin is 12 meter lang en 8 meter breed. Er moet een nieuw hek omheen.",
    "explanation": "Je loopt helemaal rond de tuin. Tel alle kanten op: 12 + 8 + 12 + 8 = 40 meter.",
    "distractorExplanations": {
      "0": "Je telde maar 2 kanten (12 + 8). Een tuin heeft 4 kanten!",
      "2": "Je deed 12 × 8. Dat is hoeveel gras erin past. Maar we willen weten: hoeveel hek eromheen?",
      "3": "Bijna! Tel de vier kanten bij elkaar op: 12 + 8 + 12 + 8."
    },
    "visualAid": {
      "type": "geo",
      "data": {
        "width": 12,
        "height": 8,
        "mode": "perimeter",
        "label": "Omtrek van de tuin"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-OMT-L2-001",
    "module": "Metriek",
    "difficulty": 104,
    "question": "Een rechthoekig zwembad is 10 meter lang en 5 meter breed. Je loopt 3 rondjes om het zwembad. Hoeveel meter heb je gelopen?",
    "options": [
      "45 meter",
      "30 meter",
      "90 meter",
      "150 meter"
    ],
    "correctAnswer": 2,
    "questionType": "multiple_choice",
    "skill": "omtrek",
    "subSkill": "omtrek",
    "familyId": "MET-OMT-ZWEMBAD",
    "explanation": "Eerst reken je één rondje uit: 10 + 5 + 10 + 5 = 30 meter. Dan keer 3: 30 × 3 = 90 meter.",
    "distractorExplanations": {
      "0": "Je deed iets bij 30, maar vergat keer 3 te doen.",
      "1": "Dit is maar één rondje! Je moest 3 rondjes lopen.",
      "3": "Je deed 10 × 5 (hoeveel erin past) en toen keer 3. Maar we willen eromheen keer 3."
    },
    "visualAid": {
      "type": "geo",
      "data": {
        "width": 10,
        "height": 5,
        "mode": "perimeter",
        "label": "Zwembad (1 rondje = 30m)"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-INH-L1-001",
    "module": "Metriek",
    "difficulty": 104,
    "question": "In een fles frisdrank zit 1,5 liter. Je schenkt glazen van 250 ml in. Hoeveel glazen haal je uit de fles?",
    "options": [
      "4 glazen",
      "6 glazen",
      "10 glazen",
      "15 glazen"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-FLES",
    "explanation": "Maak het gelijk: 1,5 liter = 1500 ml. Dan delen: 1500 : 250 = 6 glazen.",
    "distractorExplanations": {
      "0": "Je gebruikte 1 liter (1000 ml). Maar er zit 1,5 liter in de fles!",
      "2": "Check nog eens: 1500 : 250 = 6.",
      "3": "Let op de komma! 1,5 liter is 1500 ml, niet 15.000 ml."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "volume",
        "from": "l",
        "to": "ml",
        "value": 1.5,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-OPP-L1-001",
    "module": "Metriek",
    "difficulty": 104,
    "question": "De juf wil nieuwe tegels in het klaslokaal. Het lokaal is 8 meter lang en 6 meter breed. Hoeveel vierkante meter ($m^2$) tegels moet ze kopen?",
    "options": [
      "14 $m^2$",
      "48 $m^2$",
      "28 $m^2$",
      "48 m"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-OPP-KLASLOKAAL",
    "explanation": "Tegels gaan op de vloer. Dat is hoeveel erin past! Doe lengte × breedte: 8 × 6 = 48 m².",
    "distractorExplanations": {
      "0": "Je deed 8 + 6. Maar bij \"hoeveel erin past\" moet je keer elkaar doen!",
      "2": "Je rekende eromheen (8 + 6 + 8 + 6). Maar we willen de vloer weten!",
      "3": "Het getal klopt! Maar let op: het is m² (vierkante meter), niet m."
    },
    "visualAid": {
      "type": "geo",
      "data": {
        "width": 8,
        "height": 6,
        "mode": "area",
        "label": "Klaslokaal: 8 × 6 = 48 m²"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-INH-L2-001",
    "module": "Metriek",
    "difficulty": 104,
    "question": "Op een pak melk staat 1 L (liter). Jeroen drinkt een beker van 2 dl (deciliter). Hoeveel dl zit er nog in het pak?",
    "options": [
      "0,8 dl",
      "8 dl",
      "98 dl",
      "1,2 dl"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-MELK",
    "explanation": "Maak het gelijk: 1 liter = 10 deciliter. Dan eraf: 10 - 2 = 8 dl.",
    "distractorExplanations": {
      "0": "Je probeerde 1 - 0,2. Maar zet eerst alles in deciliter!",
      "2": "Je dacht dat 1 liter = 100 deciliter. Kijk naar het trapje: 1 L = 10 dl!",
      "3": "Je deed erbij in plaats van eraf. Er gaat juist melk uit het pak!"
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "volume",
        "from": "l",
        "to": "dl",
        "value": 1,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-OMT-L1-002",
    "module": "Metriek",
    "difficulty": 104,
    "question": "Een rechthoek heeft een lengte van 9 meter en een breedte van 4 meter. Wat is de omtrek?",
    "options": [
      "13 meter",
      "26 meter",
      "36 meter",
      "72 meter"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "omtrek",
    "subSkill": "omtrek",
    "familyId": "MET-OMT-RECHTHOEK",
    "explanation": "Omtrek = eromheen lopen. Loop langs alle vier de kanten: 9 + 4 + 9 + 4 = 26 meter.",
    "distractorExplanations": {
      "0": "Je telde maar twee kanten (9 + 4). Een rechthoek heeft vier kanten!",
      "2": "Je deed 9 × 4. Dat is hoeveel erin past, niet eromheen!",
      "3": "Je deed hoeveel erin past × 2. Dat klopt niet voor eromheen."
    },
    "visualAid": {
      "type": "geo",
      "data": {
        "width": 9,
        "height": 4,
        "mode": "perimeter",
        "label": "Omtrek: 9 + 4 + 9 + 4 = 26m"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-INH-L1-002",
    "module": "Metriek",
    "difficulty": 104,
    "question": "In een emmer zit 7,5 liter water. Je giet dit in flessen van 1,5 liter. Hoeveel flessen kun je vullen?",
    "options": [
      "3 flessen",
      "4 flessen",
      "5 flessen",
      "6 flessen"
    ],
    "correctAnswer": 2,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-EMMER",
    "explanation": "Kijk hoe vaak 1,5 in 7,5 past: 7,5 : 1,5 = 5. Je kunt 5 flessen vullen.",
    "distractorExplanations": {
      "0": "3 flessen = 4,5 liter. Dat is te weinig.",
      "1": "4 flessen = 6 liter. Er blijft nog 1,5 liter over!",
      "3": "6 flessen = 9 liter. Zoveel water heb je niet."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Verdelen",
        "content": "7,5 : 1,5 = 5. Je kunt 5 flessen vullen.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-OPP-L2-001",
    "module": "Metriek",
    "difficulty": 104,
    "question": "Een kamer is 4 meter lang en 3,5 meter breed. Hoeveel vierkante meter vloerbedekking is nodig?",
    "options": [
      "7 $m^2$",
      "14 $m^2$",
      "28 $m^2$",
      "12 $m^2$"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-OPP-KAMER",
    "explanation": "Voor vloerbedekking heb je \"hoeveel erin past\" nodig. Lengte × breedte: 4 × 3,5 = 14 m².",
    "distractorExplanations": {
      "0": "Je deed 4 + 3,5. Maar bij \"hoeveel erin past\" moet je keer elkaar doen!",
      "2": "Je verdubbelde de uitkomst. Maar 4 × 3,5 = 14.",
      "3": "Je deed 4 × 3. Vergeet de halve meter niet! 4 × 0,5 = 2. Dan 12 + 2 = 14."
    },
    "visualAid": {
      "type": "geo",
      "data": {
        "width": 4,
        "height": 3.5,
        "mode": "area",
        "label": "Oppervlakte: 4 × 3,5 = 14 m²"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-INH-L2-003",
    "module": "Metriek",
    "difficulty": 104,
    "question": "In een emmer zit 8 liter water. Je giet dit in bekers van 500 ml. Hoeveel bekers kun je vullen?",
    "options": [
      "16 bekers",
      "8 bekers",
      "4 bekers",
      "32 bekers"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-EMMER-BEKER",
    "explanation": "Stap 1: Maak de maten gelijk. 8 liter = 8.000 ml. Stap 2: 8.000 : 500 = 16. Je kunt 16 bekers vullen!",
    "distractorExplanations": {
      "1": "Je deed 8 : 0,5 = 16. Dat klopt! Maar het antwoord is 16 bekers, niet 8.",
      "2": "Je deed 8.000 : 1000. Maar één beker is 500 ml, niet 1000 ml!",
      "3": "Je deed 8.000 : 250. Maar één beker is 500 ml, niet 250 ml!"
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "volume",
        "from": "l",
        "to": "ml",
        "value": 8,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-OMT-L2-002",
    "module": "Metriek",
    "difficulty": 104,
    "question": "Een vierkant heeft zijden van 7 meter. Wat is de omtrek?",
    "options": [
      "14 meter",
      "21 meter",
      "28 meter",
      "49 meter"
    ],
    "correctAnswer": 2,
    "questionType": "multiple_choice",
    "skill": "omtrek",
    "subSkill": "omtrek",
    "familyId": "MET-OMT-VIERKANT",
    "explanation": "Een vierkant heeft 4 gelijke zijden. Dus: 4 × 7 = 28 meter.",
    "distractorExplanations": {
      "0": "Je deed 2 × 7. Maar een vierkant heeft 4 kanten.",
      "1": "Je deed 3 × 7. Maar je mist één kant.",
      "3": "Je deed 7 × 7. Dat is oppervlakte, niet omtrek."
    },
    "visualAid": {
      "type": "geo",
      "data": {
        "width": 7,
        "height": 7,
        "mode": "perimeter",
        "label": "Vierkant: 4 × 7 = 28 m"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-OPP-L2-002",
    "module": "Metriek",
    "difficulty": 104,
    "question": "Een speelveld is 9 meter lang en 7 meter breed. Hoeveel vierkante meter is de oppervlakte?",
    "options": [
      "16 $m^2$",
      "63 $m^2$",
      "32 $m^2$",
      "126 $m^2$"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-OPP-SPEELVELD",
    "explanation": "Oppervlakte is lengte × breedte. Dus: 9 × 7 = 63 m².",
    "distractorExplanations": {
      "0": "Je deed 9 + 7. Dat is omtrek, niet oppervlakte.",
      "2": "Je deed 8 × 4 of een andere fout. Check: 9 × 7 = 63.",
      "3": "Je deed omtrek en verdubbelde. Oppervlakte is geen optelsom."
    },
    "visualAid": {
      "type": "geo",
      "data": {
        "width": 9,
        "height": 7,
        "mode": "area",
        "label": "Oppervlakte: 9 × 7 = 63 m²"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-INH-L2-004",
    "module": "Metriek",
    "difficulty": 104,
    "question": "Er zit 3,6 liter limonade in een kan. Je schenkt bekers van 200 ml. Hoeveel bekers kun je vullen?",
    "options": [
      "12 bekers",
      "18 bekers",
      "20 bekers",
      "36 bekers"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-LIMONADE",
    "explanation": "Maak de maten gelijk: 3,6 liter = 3.600 ml. Dan delen: 3.600 : 200 = 18 bekers.",
    "distractorExplanations": {
      "0": "Je deed 3.600 : 300. Maar één beker is 200 ml.",
      "2": "Je deelde door 180. Controleer: 3.600 : 200 = 18.",
      "3": "Je vergat naar ml om te zetten en deed 3,6 : 0,2."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "volume",
        "from": "l",
        "to": "ml",
        "value": 3.6,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-INH-L2-005",
    "module": "Metriek",
    "difficulty": 104,
    "question": "In een kan zit 2,4 liter water. Je vult flesjes van 300 ml. Hoeveel flesjes kun je vullen?",
    "options": [
      "6 flesjes",
      "8 flesjes",
      "10 flesjes",
      "12 flesjes"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-FLESJES",
    "explanation": "2,4 liter = 2.400 ml. Dan delen: 2.400 : 300 = 8 flesjes.",
    "distractorExplanations": {
      "0": "Je deed 2.400 : 400. Maar een flesje is 300 ml.",
      "2": "Je deelde door 240. Check: 2.400 : 300 = 8.",
      "3": "Je deed 2,4 : 0,3 en maakte een kommafout."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "volume",
        "from": "l",
        "to": "ml",
        "value": 2.4,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-LEN-L2-003",
    "module": "Metriek",
    "difficulty": 104,
    "question": "Een lint is 2,3 meter lang. Hoeveel centimeter is dat?",
    "options": [
      "23 cm",
      "230 cm",
      "2.300 cm",
      "2,3 cm"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte",
    "familyId": "MET-LEN-LINT-L",
    "explanation": "Van meter naar centimeter zijn het 2 stappen omlaag. Dus: 2,3 × 100 = 230 cm.",
    "distractorExplanations": {
      "0": "Je deed ×10. Dat is van m naar dm.",
      "2": "Je deed ×1000. Dat is één stap te veel.",
      "3": "Je zette niets om. 2,3 m is veel meer dan 2,3 cm."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "length",
        "from": "m",
        "to": "cm",
        "value": 2.3,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-GEW-L2-002",
    "module": "Metriek",
    "difficulty": 104,
    "question": "Een tas weegt 4,5 kilogram. Hoeveel gram is dat?",
    "options": [
      "450 gram",
      "4.500 gram",
      "45.000 gram",
      "4.050 gram"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-GEW-TAS",
    "explanation": "Van kg naar g zijn het 3 stappen omlaag. Dus: 4,5 × 1000 = 4.500 gram.",
    "distractorExplanations": {
      "0": "Je deed ×100. Dat is van kg naar dag.",
      "2": "Je zette er een nul te veel bij. Het is ×1000.",
      "3": "Je maakte een kommafout. 4,5 kg is niet 4.050 g."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "weight",
        "from": "kg",
        "to": "g",
        "value": 4.5,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-VGL-M6P-001",
    "module": "Metriek",
    "difficulty": 104,
    "question": "Wat is meer: 4.200 gram of 4 kilogram?",
    "options": ["4.200 gram", "4 kilogram", "Even veel", "Niet te zeggen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "vergelijken",
    "subSkill": "vergelijken",
    "familyId": "MET-VGL-G-KG-M6P",
    "explanation": "4 kg = 4.000 gram. 4.200 gram is meer dan 4.000 gram.",
    "distractorExplanations": {
      "1": "4 kg is 4.000 gram. 4.200 gram is 200 gram meer.",
      "2": "Ze zijn niet even veel. 4.200 g is meer.",
      "3": "Je kunt het vergelijken door om te rekenen."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "weight",
        "from": "kg",
        "to": "g",
        "value": 4,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-VGL-M6P-002",
    "module": "Metriek",
    "difficulty": 104,
    "question": "Wat is langer: 2,8 km of 3.000 meter?",
    "options": ["3.000 meter", "2,8 km", "Even lang", "Niet te zeggen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "vergelijken",
    "subSkill": "vergelijken",
    "familyId": "MET-VGL-KM-M-M6P",
    "explanation": "2,8 km = 2.800 meter. 3.000 meter is meer dan 2.800 meter.",
    "distractorExplanations": {
      "1": "2,8 km is 2.800 meter. Dat is minder dan 3.000 meter.",
      "2": "Ze zijn niet even lang. 3.000 meter is langer.",
      "3": "Je kunt het vergelijken door om te rekenen."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "length",
        "from": "km",
        "to": "m",
        "value": 2.8,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-VGL-M6P-003",
    "module": "Metriek",
    "difficulty": 104,
    "question": "Zet in de juiste volgorde van licht naar zwaar: 500 g, 1,2 kg, 0,8 kg",
    "options": ["500 g — 0,8 kg — 1,2 kg", "0,8 kg — 500 g — 1,2 kg", "1,2 kg — 0,8 kg — 500 g", "500 g — 1,2 kg — 0,8 kg"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "vergelijken",
    "subSkill": "vergelijken",
    "familyId": "MET-VGL-SORT-M6P",
    "explanation": "Maak alles gram: 500 g, 1.200 g, 800 g. Van licht naar zwaar: 500 — 800 — 1.200.",
    "distractorExplanations": {
      "1": "0,8 kg = 800 gram. Dat is meer dan 500 gram.",
      "2": "Dit is van zwaar naar licht.",
      "3": "0,8 kg is niet lichter dan 1,2 kg. Check de volgorde."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "weight",
        "from": "kg",
        "to": "g",
        "value": 0.8,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-SCHAT-M6P-001",
    "module": "Metriek",
    "difficulty": 104,
    "question": "Hoeveel liter past er ongeveer in een aquarium voor goudvissen?",
    "options": ["50 liter", "5 liter", "500 liter", "5.000 liter"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud_schatten",
    "familyId": "MET-SCHAT-AQUA-M6P",
    "explanation": "Een klein aquarium voor goudvissen bevat ongeveer 50 liter water.",
    "distractorExplanations": {
      "1": "Dat is maar een halve emmer. Veel te weinig voor een aquarium.",
      "2": "Dat is een heel groot aquarium, meer voor een dierentuin.",
      "3": "Dat is een klein zwembad. Veel te groot voor een aquarium."
    }
  },
  {
    "id": "MET-SCHAT-M6P-002",
    "module": "Metriek",
    "difficulty": 104,
    "question": "Hoeveel weegt een volle schooltas ongeveer?",
    "options": ["5 kilogram", "50 gram", "50 kilogram", "500 gram"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht_schatten",
    "familyId": "MET-SCHAT-TAS-M6P",
    "explanation": "Een volle schooltas met boeken weegt ongeveer 5 kilogram.",
    "distractorExplanations": {
      "1": "Dat is lichter dan een appel. Een schooltas is veel zwaarder!",
      "2": "Dat is zo zwaar als een kind. Veel te zwaar voor een tas!",
      "3": "Dat is een halve kilogram. Een volle tas is zwaarder."
    }
  },
  {
    "id": "MET-LKOM-M6P-001",
    "module": "Metriek",
    "difficulty": 104,
    "question": "Reken om: 3,25 meter = ... cm",
    "options": ["325 cm", "32,5 cm", "3.250 cm", "30,25 cm"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte_komma",
    "familyId": "MET-LKOM-M-CM-M6P",
    "explanation": "1 meter = 100 cm. 3,25 × 100 = 325 cm.",
    "distractorExplanations": {
      "1": "Je deed ×10 in plaats van ×100.",
      "2": "Je deed ×1.000. Dat is te veel.",
      "3": "Je verplaatste de komma verkeerd."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "length",
        "from": "m",
        "to": "cm",
        "value": 3.25,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-LKOM-M6P-002",
    "module": "Metriek",
    "difficulty": 104,
    "question": "Reken om: 4,6 km = ... meter",
    "options": ["4.600 m", "460 m", "46.000 m", "46 m"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte_komma",
    "familyId": "MET-LKOM-KM-M-M6P",
    "explanation": "1 km = 1.000 m. 4,6 × 1.000 = 4.600 meter.",
    "distractorExplanations": {
      "1": "Je deed ×100 in plaats van ×1.000.",
      "2": "Je deed ×10.000. Dat is te veel.",
      "3": "Je deed ×10. Dat is te weinig."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "length",
        "from": "km",
        "to": "m",
        "value": 4.6,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-GKOM-M6P-001",
    "module": "Metriek",
    "difficulty": 104,
    "question": "Reken om: 3,75 kg = ... gram",
    "options": ["3.750 gram", "375 gram", "37.500 gram", "3.075 gram"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht_komma",
    "familyId": "MET-GKOM-KG-G-M6P",
    "explanation": "1 kg = 1.000 gram. 3,75 × 1.000 = 3.750 gram.",
    "distractorExplanations": {
      "1": "Je deed ×100 in plaats van ×1.000.",
      "2": "Je deed ×10.000. Dat is te veel.",
      "3": "Je maakte een kommafout."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "weight",
        "from": "kg",
        "to": "g",
        "value": 3.75,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-GKOM-M6P-002",
    "module": "Metriek",
    "difficulty": 104,
    "question": "Reken om: 1.250 gram = ... kg",
    "options": ["1,25 kg", "12,5 kg", "0,125 kg", "125 kg"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht_komma",
    "familyId": "MET-GKOM-G-KG-M6P",
    "explanation": "1.000 gram = 1 kg. 1.250 : 1.000 = 1,25 kg.",
    "distractorExplanations": {
      "1": "Je deelde door 100 in plaats van 1.000.",
      "2": "Je deelde door 10.000. Dat is te veel.",
      "3": "Je deed ×100 in plaats van ÷1.000."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "weight",
        "from": "g",
        "to": "kg",
        "value": 1250,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  }
]